<mat-form-field class="list-filter" appearance="standard">
  <mat-label>{{ label }}</mat-label>
  <mat-select (selectionChange)="selectOption()" [(value)]="selected">
    <mat-option class="select-all">{{ allLabel }}</mat-option>
    <mat-option *ngFor="let option of options" [value]="option.id">
      {{ option.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
